import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

const getClinicPartnerAvgPainQueryKey = () => ["getClinicPartnerAvgPain"] as const;

export const useGetClinicPartnerAvgPain = () => {
  const client = useApiClient();

  return useQuery(getClinicPartnerAvgPainQueryKey(), () => client.getClinicPartnerAvgPain());
};
